export enum AmountPayments {
  FourPayments = 4,
  SixPayments = 6,
}

export interface PaymentsSchedule {
  amountPayments: AmountPayments;
  firstPayment?: number;
  paymentSum?: number;
  otherPayments?: number;
  paymentsDates?: string[];
}
